import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import {addUser} from "./service";

/**
 * Create Company
 */
function* createUser({ postData }) {
  console.log(postData);
  try {
    const { data } = yield call(addUser, postData);
    yield put({
      type: Actions.CREATE_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Actions.CREATE_USER_ERROR,
      error: error,
    });
  }
}

export default function* userSaga() {
    yield takeEvery(Actions.CREATE_USER, createUser);
}